import { ItemCardDetails } from "@/components/ItemCard";
import { type QuotationInfo } from "@repo/api";
import { Badge, LightMode } from "@repo/skapa";
import { t, useTranslation } from "@repo/translation";
import {
  LocalizedDateAndTime,
  SimpleLabelField,
  localizeDateAndTime,
} from "@repo/ui";

import { getExpiryStatus, isExpiringSoon } from "./utils";

interface QuotationCardDetailsProps {
  quotation: QuotationInfo;
}
export const QuotationCardDetails = ({
  quotation,
}: QuotationCardDetailsProps) => {
  const { dateFnsLocale } = useTranslation();

  return (
    <ItemCardDetails
      title={`${quotation.title ? `${quotation.title} ` : ""}${quotation.id}`}
      description={`${t("label.created")}: ${localizeDateAndTime(quotation.createdTime, dateFnsLocale)}`}
      addOn={
        <div>
          <SimpleLabelField
            small
            label={t("label.total_articles")}
            value={quotation.noOfItems ?? "-"}
            color={LightMode.colourTextAndIcon2}
          />

          <SimpleLabelField
            small
            label={t("label.status")}
            value={quotation.status}
            color={LightMode.colourTextAndIcon2}
          />

          <SimpleLabelField
            small
            label={t("label.store_number")}
            value={quotation.buCode}
            color={LightMode.colourTextAndIcon2}
          />
          <SimpleLabelField
            small
            label={t("label.expiry_date")}
            value={<LocalizedDateAndTime date={quotation.expiryDate} />}
            color={LightMode.colourTextAndIcon2}
          />
          {isExpiringSoon(quotation.expiryDate) && (
            <div style={{ marginTop: "5px" }}>
              <Badge
                label={<>{getExpiryStatus(quotation.expiryDate).text}</>}
                colour={getExpiryStatus(quotation.expiryDate).color}
                size="small"
              />
            </div>
          )}
        </div>
      }
    />
  );
};
